import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemedButton } from '@awarego-ui/components';
import styled, { css } from 'styled-components';

const ThemedFooterLinkButton = styled(ThemedButton)`
    margin: 0 20px;
    ${(props) =>
        props.continue &&
        css`
            margin-left: auto;
        `};
`;

const ThemedFooterButton = (props) => {
    const navigate = useNavigate();
    const {
        to,
        onClick,
        className,
        ...rest
    } = props;
    return (
        <ThemedFooterLinkButton
            className={['ag-player-btn', className].filter(Boolean).join(' ')}
            {...rest} // `children` is just another prop!
            onClick={(event) => {
                onClick && onClick(event);
                if( to && !onClick )
                    navigate(to);
            }}
        />
    );
};

export default ThemedFooterButton;
